import { createI18n } from 'vue-i18n';
import en from './locales/en.json';
import ar from './locales/ar.json';

const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem('locale') || 'en',
  fallbackLocale: 'en',
  messages: {
    en,
    ar,
  },
  // Disable warnings
  missingWarn: false,
  fallbackWarn: false,
  // Disable message format validation that might cause issues
  silentTranslationWarn: true,
  silentFallbackWarn: true,
  // Use simple message format - disable linked message support
  // This prevents vue-i18n from trying to parse @: syntax
  warnHtmlMessage: false,
});

export default i18n;

